import { jsxs as c, jsx as t } from "react/jsx-runtime";
import { useState as u, useEffect as I } from "react";
import { isValidHex as x } from "@givebutter/util";
import { Root as O, Form as R } from "../input/Input.js";
import { Label as L } from "../label/Label.js";
import { Root as j, Item as S } from "../radio-group/RadioGroup.js";
import { getFocusColor as _, Swatch as z } from "./Swatch.js";
import { DEFAULT_COLORS as E, getColorName as N, NO_COLOR as H } from "./utils.js";
const J = ({
  value: s,
  allowNoColor: g = !1,
  onValueChange: a,
  onClickColor: l,
  onChange: o,
  onBlur: d,
  colors: v,
  name: p,
  ...y
}) => {
  const b = [...[H].filter((e) => g), ...v ?? E], [i, f] = u(s ?? ""), [m, n] = u(i.replace("#", ""));
  I(() => {
    s && f(s);
  }, [s]);
  const h = (e) => {
    const r = e.replace("#", "");
    f(e), n(r), a == null || a(e);
  }, k = (e) => (r) => {
    h(e), l == null || l(r);
  }, w = (e) => {
    const r = e.target.value.trim().replace("#", "");
    n(r), o == null || o(e), r.length === 6 && x(r) && h("#" + r);
  }, F = (e) => {
    x(m) || n(i), d == null || d(e);
  };
  return /* @__PURE__ */ c("div", { className: "flex flex-col gap-1", children: [
    /* @__PURE__ */ c(j, { className: "flex flex-row flex-wrap gap-1.5", children: [
      b.map((e) => /* @__PURE__ */ c(
        S,
        {
          id: e,
          value: e,
          className: "radix-state-checked:ring-2 radix-state-checked:ring-current radix-state-checked:bg-unset h-fit w-fit shrink-0 rounded-md border-none p-0 outline-none ring-offset-2 focus-visible:ring-2 focus-visible:ring-current",
          style: { color: _(e) },
          onClick: k(e),
          checked: e === i,
          autoFocus: e === i,
          children: [
            /* @__PURE__ */ t("span", { className: "sr-only", children: N(e) }),
            /* @__PURE__ */ t(z, { color: e, className: "size-8 cursor-pointer rounded-md" })
          ]
        },
        e
      )),
      /* @__PURE__ */ t("div", { children: /* @__PURE__ */ c("div", { className: "flex flex-nowrap items-center", children: [
        /* @__PURE__ */ t(
          "div",
          {
            className: "input-left flex size-8 items-center justify-center rounded-lg bg-gray-200",
            children: /* @__PURE__ */ t("p", { className: "text-gray-400", "aria-hidden": !0, children: "#" })
          }
        ),
        !p && /* @__PURE__ */ t(L, { htmlFor: "color-input", className: "sr-only", children: "Custom color" }),
        /* @__PURE__ */ t(O, { className: "input-right h-8 py-0", children: /* @__PURE__ */ t(
          R,
          {
            onBlur: F,
            onChange: w,
            value: m.replace("#", "").toUpperCase(),
            className: "h-8",
            name: p ?? "color-input",
            ...y
          }
        ) })
      ] }) })
    ] }),
    i && /* @__PURE__ */ t("p", { className: "text-sm text-gray-600", "aria-hidden": !0, children: N(i) ?? "custom color" })
  ] });
};
export {
  J as ColorPickerInput
};
